export default __webpack_public_path__ + "static/AlmarenaDisplayRegular-914e11abebb485cc3bc9dcf8ab330b44.woff2";